'use strict';
(() => {
  const root=document.querySelector('[data-mn-price-entry]');
  if(!root)return;
  const frame=document.querySelector('iframe.mncs-frame[data-mn-site-shell="embedded"]');
  const parentMode=!!frame,embedded=window.parent!==window;
  const allowed=['https://miamineons.com','https://www.miamineons.com','https://te0j25-2a.myshopify.com'];
  const money=value=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',minimumFractionDigits:0,maximumFractionDigits:0}).format(value);
  const button=root.querySelector('[data-entry-begin]'),status=root.querySelector('[data-entry-status]');
  const originalLabel=button.textContent;
  const modeButtons=[...root.querySelectorAll('[data-entry-mode]')],sizeButtons=[...root.querySelectorAll('[data-entry-width]')];
  let mode='words',width=36,touched=false,restored=false,ready=false,waiting=false,request=null,timeout;
  try{const requested=Number(new URLSearchParams(location.search).get('size'));if(NeonPriceEntry.widths.includes(requested)){width=requested;touched=true;}}catch{}
  const selection=()=>({mode,width,resume:restored&&!touched});
  function sync(){
    for(const control of modeButtons){const active=control.dataset.entryMode===mode;control.setAttribute('aria-pressed',String(active));control.classList.toggle('selected',active);}
    for(const control of sizeButtons){
      const size=Number(control.dataset.entryWidth),active=size===width,cost=NeonPriceEntry.price(mode,size);
      control.setAttribute('aria-pressed',String(active));control.classList.toggle('selected',active);
      control.querySelector('[data-entry-price]').textContent=mode==='logo'?money(cost.from)+'–'+money(cost.to):money(cost.from);
    }
    const cost=NeonPriceEntry.price(mode,width);
    root.querySelector('[data-entry-total]').textContent=mode==='logo'?money(cost.from)+'–'+money(cost.to):money(cost.from);
    root.querySelector('[data-entry-selected]').textContent=width+'″ '+(mode==='logo'?root.dataset.logoAxis:root.dataset.textAxis);
    root.querySelector('[data-entry-note]').textContent=mode==='logo'?root.dataset.logoNote:root.dataset.textNote;
    const tier=root.querySelector('[data-entry-tier]');tier.hidden=mode!=='logo';tier.textContent=mode==='logo'?root.dataset.tierLabel.replace('[simple]',money(cost.from)).replace('[standard]',money(cost.standard)).replace('[designer]',money(cost.to)):'';
    if(!waiting)button.textContent=restored&&!touched?root.dataset.resumeLabel:originalLabel;
  }
  const track=(name,details={})=>{
    if(parentMode)window.MNBehaviorTracking?.record(name,{design_mode:mode,width_inches:width,step:'size',...details});
    else window.MNCustomizerTracking?.emit(name,{design_mode:mode,width_inches:width,step:'size',...details});
  };
  function choose(){touched=true;sync();track('mn_customizer_option_select',{action:'width'});}
  modeButtons.forEach(control=>control.addEventListener('click',()=>{mode=control.dataset.entryMode;choose();}));
  sizeButtons.forEach(control=>control.addEventListener('click',()=>{width=Number(control.dataset.entryWidth);choose();}));
  function finish(){
    clearTimeout(timeout);waiting=false;root.hidden=true;
    document.documentElement.classList.remove('mn-price-entry-open');
    if(parentMode){frame.closest('[data-mn-customizer]').dataset.mnEntryOpen='false';frame.focus({preventScroll:true});}
    else {window.requestAnimationFrame(()=>{if(typeof render==='function')render();document.querySelector('#words')?.focus({preventScroll:true});});}
  }
  function sendBegin(){
    if(!ready||!waiting)return;
    if(parentMode){request=crypto.randomUUID();frame.contentWindow.postMessage({type:'mn:customizer:begin',version:1,requestId:request,...selection()},new URL(frame.src).origin);}
    else begin(selection());
  }
  function begin(value){
    if(!ready)return;
    state=NeonPriceEntry.apply(state,value);
    document.querySelector('#words').value=state.text;
    if(typeof view==='object'){view.x=0;view.y=0;view.zoom=1;}
    window.MNCustomizerTracking?.begin?.();
    if(typeof render==='function')render();
    finish();
  }
  button.addEventListener('click',()=>{
    waiting=true;button.disabled=true;status.textContent=root.dataset.openingLabel;button.textContent=root.dataset.openingButton;
    timeout=setTimeout(()=>{if(root.hidden)return;waiting=false;button.disabled=false;button.textContent=originalLabel;status.textContent=root.dataset.waitLabel;},15000);
    sendBegin();
  });
  window.addEventListener('message',event=>{
    const data=event.data;if(!data||data.version!==1)return;
    if(parentMode){
      if(event.source!==frame.contentWindow||event.origin!==new URL(frame.src).origin)return;
      if(data.type==='mn:customizer:entry-ready'){
        ready=true;restored=data.restored===true;
        if(restored&&!touched&&NeonPriceEntry.widths.includes(data.width)&&['words','logo'].includes(data.mode)){width=data.width;mode=data.mode;sync();}
        sendBegin();
      }else if(data.type==='mn:customizer:begun'&&data.requestId===request)finish();
    }else if(embedded&&event.source===window.parent&&allowed.includes(event.origin)&&data.type==='mn:customizer:begin'&&ready){
      try{NeonPriceEntry.price(data.mode,data.width);begin({mode:data.mode,width:Number(data.width),resume:data.resume===true});window.parent.postMessage({type:'mn:customizer:begun',version:1,requestId:data.requestId},event.origin);}catch{}
    }
  });
  if(!parentMode){
    document.documentElement.classList.add('mn-price-entry-open');
    window.MNPriceFirst=Object.freeze({
      get active(){return !root.hidden;},
      ready(){
        ready=true;restored=window.neonDraftRestored===true;
        if(restored&&!touched&&NeonPriceEntry.widths.includes(state.width)){width=state.width;mode=state.designMode;sync();}
        if(embedded)allowed.forEach(origin=>window.parent.postMessage({type:'mn:customizer:entry-ready',version:1,restored,width:state.width,mode:state.designMode},origin));
        track('mn_price_view',{pricing_type:'shopify'});sendBegin();
      }
    });
  }
  sync();
  if(parentMode)track('mn_price_view',{pricing_type:'shopify'});
})();
